import { CustomElement } from '@aurelia/runtime-html';
export const name = "message-component";
export const template = "<div if.bind=\"!isClosed\" class=\"font-raleway text-small-medium p-2 rounded-lg message-${messageStyle}\">\n  <div class=\"flex flex-row justify-between items-start gap-1\">\n    <div class=\"flex items-start gap-1\">\n      <div class=\"icon-box-md text-xl\">\n        <i class=\"${getIcon(messageStyle)}\"></i>\n      </div>\n      <span>${message}</span>\n    </div>\n    <div class=\"icon-box-md !text-base/4 cursor-pointer\">\n      <i if.bind=\"canClose\" click.trigger=\"closeMessage()\" class=\"mdi mdi-window-close s\"></i>\n    </div>\n  </div>\n  <au-slot name=\"buttons\">\n\n  </au-slot>\n</div>";
export default template;
export const dependencies = [  ];
export const bindables = {};
let _e;
export function register(container) {
  if (!_e) {
    _e = CustomElement.define({ name, template, dependencies, bindables });
  }
  container.register(_e);
}
